// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  text: "시험 서버",
  production: false,
  useHash: false,
  server: 'https://han-dev-api.listenandlearnkorean.com',
  naverClientId: "kKYTXuJfatGHYp9FV3M4",
  naverCallbackUrl: "https://han-dev-m.listenandlearnkorean.com/callback/naver", // Web
  naverCallbackUrlAndroid: "https://han-dev-m.listenandlearnkorean.com/callback/naver-android", // Android
  naverCallbackUrlIOS: "https://han-dev-m.listenandlearnkorean.com/callback/naver-ios", // IOS
  donationUrl: "https://kko.to/W1hxYd74T",
  iosAppId: "6739878324",
  iosAppName: "%EB%93%A3%EA%B3%A0-%EB%B0%B0%EC%9A%B0%EB%8A%94-%ED%95%9C%EA%B5%AD%EC%96%B4",
  androidAppId: "com.listenandlearnkorean.gukeodev",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
